import { CheckSquare, Loader2, Square, TriangleAlert } from "lucide-react";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

export interface BatchItemsToolbarProps {
  onSelectAllValid: () => void;
  onDeselectAll: () => void;
  onExcludeWithWarnings: () => void;
  disabled: boolean;
  isSyncing: boolean;
}

/** Bulk selection ops — each is one server-side PATCH, never a loop over rows. */
export function BatchItemsToolbar({
  onSelectAllValid,
  onDeselectAll,
  onExcludeWithWarnings,
  disabled,
  isSyncing,
}: BatchItemsToolbarProps) {
  const { t } = useTranslations("payoutBatches");
  return (
    <div className="flex flex-wrap items-center gap-2">
      <ColocaButton
        variant="default"
        size="sm"
        icon={CheckSquare}
        disabled={disabled}
        onClick={onSelectAllValid}
      >
        {t("items_select_all_valid")}
      </ColocaButton>
      <ColocaButton variant="default" size="sm" icon={Square} disabled={disabled} onClick={onDeselectAll}>
        {t("items_deselect_all")}
      </ColocaButton>
      <ColocaButton
        variant="default"
        size="sm"
        icon={TriangleAlert}
        disabled={disabled}
        onClick={onExcludeWithWarnings}
      >
        {t("items_exclude_with_warnings")}
      </ColocaButton>
      {isSyncing && (
        <span className="ml-auto flex items-center gap-1.5 text-xs text-muted-foreground" aria-live="polite">
          <Loader2 aria-hidden="true" className="size-3.5 animate-spin" />
          {t("items_syncing")}
        </span>
      )}
    </div>
  );
}
